// src/components/navbar.jsx
import React, { useEffect, useRef, useState, useMemo } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./nav.css";

/* ---------------- Icone inline (svg / emoji) ---------------- */
function Icon({ name, className = "nav-ic" }) {
  switch (name) {
    case "tasks":
      // icona "checklist" per Gestione
      return (
        <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
          <path d="M3 5h11v2H3V5zm0 6h11v2H3v-2zm0 6h11v2H3v-2zM18.59 5.59 17.17 7l-2.12-2.12L16.05 3l2.54 2.59zM18.59 11.59 17.17 13l-2.12-2.12 1-1 2.54 1.71zM18.59 17.59 17.17 19l-2.12-2.12 1-1 2.54 1.71z" />
        </svg>
      );
    case "list":
      return (
        <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
          <path d="M4 6h16v2H4V6zm0 5h16v2H4v-2zm0 5h16v2H4v-2z" />
        </svg>
      );
    case "plus":
      return (
        <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
          <path d="M11 5h2v14h-2V5zm-6 6h14v2H5v-2z" />
        </svg>
      );
    case "calendar":
      return (
        <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
          <path d="M7 2a1 1 0 0 0-1 1v1H5a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3h-1V3a1 1 0 1 0-2 0v1H8V3a1 1 0 0 0-1-1ZM5 8h14v10a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V8Z" />
        </svg>
      );
    case "tag":
      return (
        <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
          <path d="M10.59 2 2 10.59V22h11.41L22 12.41 10.59 2zM7 9.5A1.5 1.5 0 1 0 8.5 8 1.5 1.5 0 0 0 7 9.5z" />
        </svg>
      );
    case "users":
      return (
        <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
          <path d="M16 11c1.66 0 3-1.57 3-3.5S17.66 4 16 4s-3 1.57-3 3.5S14.34 11 16 11zM8 11c1.66 0 3-1.57 3-3.5S9.66 4 8 4 5 5.57 5 7.5 6.34 11 8 11zm0 2c-2.33 0-7 1.17-7 3.5V20h14v-3.5C15 14.17 10.33 13 8 13zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V20h5v-3.5c0-2.33-4.67-3.5-6-3.5z" />
        </svg>
      );
    case "lock":
      return (
        <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 17a2 2 0 0 0 2-2v-2a2 2 0 1 0-4 0v2a2 2 0 0 0 2 2zm6-6h-1V9a5 5 0 1 0-10 0v2H6a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2zm-7-2a3 3 0 1 1 6 0v2H11V9z" />
        </svg>
      );
    case "chart":
      return (
        <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
          <path d="M11 2a1 1 0 0 0-1 1v9H2a1 1 0 0 0-1 1 10 10 0 1 0 10-11zM13 2.06V12h9.94A10.02 10.02 0 0 0 13 2.06z" />
        </svg>
      );
    case "shield":
      return (
        <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 2 4 5v6c0 5 3.4 9.4 8 11 4.6-1.6 8-6 8-11V5l-8-3z" />
        </svg>
      );
    case "gps":
      return (
        <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
          <path d="M11 2v2.06A8.002 8.002 0 0 0 4.06 11H2v2h2.06A8.002 8.002 0 0 0 11 19.94V22h2v-2.06A8.002 8.002 0 0 0 19.94 13H22v-2h-2.06A8.002 8.002 0 0 0 13 4.06V2h-2zm1 5a5 5 0 1 1 0 10 5 5 0 0 1 0-10z" />
        </svg>
      );
    case "chat":
      // icona chat per messaggistica interna (emoji 💬)
      return (
        <span
          className={`${className} nav-emoji`}
          role="img"
          aria-label="Chat"
        >
          💬
        </span>
      );
    default:
      return null;
  }
}

/* ---------------- Voci menu ---------------- */
const MENU_ITEMS = [
  { key: "elenco",     label: "Elenco",      to: "/elenco",      icon: "list" },
  { key: "nuovo",      label: "Nuovo",       to: "/nuovo",       icon: "plus" },
  { key: "agendaPro",  label: "Agenda",      to: "/agenda-pro",  icon: "calendar", extraCls: "nav-agenda-pro" },
  { key: "agendaCall", label: "Agenda Call", to: "/agenda-call", icon: "calendar" },
  { key: "gestione",   label: "Gestione",    to: "/gestione",    icon: "tasks",   extraCls: "nav-gestione" },
  { key: "agendaPosa", label: "Agenda Posa", to: "/agenda-posa", icon: "calendar", extraCls: "nav-agenda-posa" },
  { key: "listino",    label: "Listino",     to: "/listino",     icon: "tag" },
  { key: "utenti",     label: "Utenti",      to: "/utenti",      icon: "users" },
  { key: "statistiche",label: "Statistiche", to: "/statistiche", icon: "chart",   extraCls: "nav-stats" },
  { key: "acl",        label: "Access",      to: "/acl",         icon: "shield",  extraCls: "nav-acl" },
];

/* ---------------- Chi vede cosa (fallback ruoli) ---------------- */
const ALLOWED_BY_ROLE = {
  rilevatore:   ["elenco", "nuovo", "agendaPro"],
  senior:       ["elenco", "nuovo", "agendaPro"],
  responsabile: ["elenco", "agendaPro", "agendaPosa"],
  centralino:   ["elenco", "nuovo", "agendaPro", "agendaCall", "agendaPosa"],
  formatore:    ["elenco", "nuovo", "agendaPro", "agendaCall", "agendaPosa", "gestione", "listino", "utenti", "statistiche"],
  senior_posa:  ["elenco", "nuovo", "agendaPro", "agendaPosa"],
  admin:        MENU_ITEMS.map((m) => m.key),
  default:      ["elenco", "nuovo", "agendaPro"],
};

/* Capability usata per mostrare "Gestione" */
const CAP_GESTIONE = "gestione.access";
/* Capability per pulsante chat (gestita da AccessMatrix/DB) */
const CAP_CHAT = "chat.use";

/* ---------------- Alias ruoli → ruolo canonico ---------------- */
const ROLE_MAP = {
  callcenter: "centralino", call_center: "centralino", cc: "centralino",
  responsabile_zona: "responsabile", responsabile_di_zona: "responsabile",
  "responsabile di zona": "responsabile", resp_zona: "responsabile", manager_zona: "responsabile",
  trainer: "formatore", tecnico_senior: "senior", tecnico: "rilevatore",
  "senior posa": "senior_posa", "senior-posa": "senior_posa", seniorposa: "senior_posa",
  "tecnico posa": "senior_posa", tecnico_posa: "senior_posa", tecnicoposa: "senior_posa", posa: "senior_posa",
};
const canonRole = (u) => {
  const raw = String(u?.role_slug || u?.role || u?.ruolo || "").trim().toLowerCase();
  return ROLE_MAP[raw] || raw || "ospite";
};

/* ---------------- Helper AUTH + util ---------------- */
function getCookie(name) {
  if (typeof document === "undefined" || !document.cookie) return "";
  const pairs = document.cookie.split(";");
  for (const part of pairs) {
    const [k, ...rest] = part.trim().split("=");
    if (k === name) return decodeURIComponent(rest.join("="));
  }
  return "";
}

function humanName(user) {
  const direct = (user?.nome || user?.display_name || "").trim();
  if (direct) return direct;
  const email = String(user?.email || "").trim();
  if (!email) return (user?.id ? `#${user.id}` : "—");
  const base = email.split("@")[0].replace(/[._-]+/g, " ").trim();
  const titled = base
    .split(/\s+/)
    .map((s) =>
      s ? s[0].toUpperCase() + s.slice(1).toLowerCase() : ""
    )
    .join(" ");
  return titled || email;
}

/** Format data/ora tipo 15/11/2025 18:44 */
function formatDateTime(dtStr) {
  if (!dtStr) return "";
  const d = new Date(dtStr.replace(" ", "T"));
  if (Number.isNaN(d.getTime())) return dtStr;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  return `${dd}/${mm}/${yyyy} ${hh}:${min}`;
}

/** Header auth robusti (Bearer + X-Auth-Token) */
function authHeaders() {
  // 1️⃣ Prova prima eventuale Bearer già noto o token salvato in localStorage
  let t =
    window.__AUTH_BEARER__ ||
    localStorage.getItem("authToken") ||
    localStorage.getItem("token") ||
    // 2️⃣ Se non c’è nulla, usa direttamente i cookie di sessione/JWT
    getCookie("PRINF_JWT") ||
    getCookie("PRINFSESSID") ||
    getCookie("PHPSESSID") ||
    "";

  const h = {};
  if (t) {
    h.Authorization = `Bearer ${t}`;
    h["X-Auth-Token"] = t;
    if (!window.__AUTH_BEARER__) window.__AUTH_BEARER__ = t;
  }
  return h;
}
/** Se non ho un Bearer, provo solo a verificare che la sessione sia valida.
 *  Se /preventivi/api/me.php risponde con un utente valido, considero OK.
 *  Eventuale JWT vero restituito dal BE viene salvato, ma NON creo token finti.
 */
async function ensureIdentity() {
  // Se abbiamo già un token/bearer noto → ok
  if (
    window.__AUTH_BEARER__ ||
    localStorage.getItem("authToken") ||
    localStorage.getItem("token")
  ) {
    return true;
  }

  try {
    const res = await fetch("/preventivi/api/me.php", {
      credentials: "include",
      cache: "no-store",
    });

    if (!res.ok) return false;

    const j = await res.json().catch(() => ({}));
    const u = j?.user || j || {};
    const id = Number(u.id || u.user_id || 0);
    if (!id) return false;

    // Se il backend restituisce un vero JWT/token, lo usiamo.
    const realToken =
      j.jwt || j.token || j.access_token || j.bearer || null;

    if (realToken) {
      window.__AUTH_BEARER__ = realToken;
      try {
        localStorage.setItem("authToken", realToken);
      } catch {}
    }

    // Anche se non abbiamo un JWT esplicito, la sessione cookie è valida.
    // authHeaders() userà PRINF_JWT / PRINFSESSID come Bearer.
    return true;
  } catch {
    return false;
  }
}


/** POST JSON generica */
async function postJSON(url, body) {
  const doPost = async () => {
    const res = await fetch(url, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json", ...authHeaders() },
      body: JSON.stringify(body || {}),
    });
    const ct = res.headers.get("content-type") || "";
    if (ct.includes("application/json")) {
      const j = await res.json().catch(() => ({}));
      return { res, data: j };
    }
    const txt = await res.text().catch(() => "");
    return { res, data: { ok: res.ok, status: res.status, raw: txt } };
  };

  try {
    let { res, data } = await doPost();
    const looksAuthError =
      res.status === 401 ||
      res.status === 403 ||
      (data && data.ok === false && /auth_required/i.test(String(data.error || "")));

    if (looksAuthError) {
      const ok = await ensureIdentity();
      if (ok) {
        ({ res, data } = await doPost());
      }
    }
    return data;
  } catch (e) {
    return { ok: false, error: String(e) };
  }
}

/* ====== POST form-encoded per posizione/consenso ====== */
const POS_URL = new URL(
  "/preventivi/position/save_position.php",
  window.location.origin
).href;
const CONSENT_URL = new URL(
  "/preventivi/position/set_consent.php",
  window.location.origin
).href;

function getCsrfToken() {
  const m = document.querySelector(
    'meta[name="csrf-token"], meta[name="csrf"], meta[name="X-CSRF-Token"]'
  );
  if (m && m.content) return m.content;
  return getCookie("XSRF-TOKEN") || getCookie("CSRF-TOKEN") || "";
}

async function postForm(url, data, csrfToken) {
  const body = new URLSearchParams();
  Object.entries(data || {}).forEach(([k, v]) =>
    body.append(k, v ?? "")
  );

  const res = await fetch(url, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      "X-Requested-With": "XMLHttpRequest",
      ...authHeaders(),
      ...(csrfToken ? { "X-CSRF-Token": csrfToken } : {}),
    },
    body,
  });

  const text = await res.text();
  if (!res.ok)
    throw new Error(`POST ${url}: ${res.status} ${res.statusText} — ${text}`);
  return text;
}

/** Salva posizione corrente sul server, ignorando AUTH_REQUIRED / NO_CONSENT */
async function savePosition({ lat, lon, acc }) {
  const csrfToken = getCsrfToken();

  const body = new URLSearchParams();
  body.set("lat", lat != null ? String(lat) : "");
  body.set("lon", lon != null ? String(lon) : "");
  body.set("acc", acc != null ? String(Math.round(acc)) : "");
  body.set("ts", String(Date.now()));

  try {
    const res = await fetch(POS_URL, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type":
          "application/x-www-form-urlencoded;charset=UTF-8",
        "X-Requested-With": "XMLHttpRequest",
        ...authHeaders(),
        ...(csrfToken ? { "X-CSRF-Token": csrfToken } : {}),
      },
      body,
    });

    const text = await res.text().catch(() => "");

    if (
      res.status === 401 ||
      res.status === 403 ||
      text.includes("AUTH_REQUIRED") ||
      text.includes("NO_CONSENT")
    ) {
      return;
    }

    if (!res.ok) {
      console.warn(
        "save_position.php error:",
        res.status,
        text.slice(0, 200)
      );
    }
  } catch (e) {
    console.warn("savePosition failed:", e);
  }
}

/** Aggiorna il consenso tracking sul server (form-encoded) */
async function setTrackConsent(granted) {
  const csrfToken = getCsrfToken();
  const payload = { consente_tracking: granted ? 1 : 0 };
  try {
    await postForm(CONSENT_URL, payload, csrfToken);
  } catch (e) {
    console.warn("setTrackConsent failed:", e);
  }
}

/* ===========================================================
   Navbar con tracker posizione + Chat interna
   =========================================================== */
export default function NavBar() {
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const user = auth?.user || {};
  const token = auth?.token || auth?.accessToken || "";

  // Esponi subito un eventuale token noto
  useEffect(() => {
    const t =
      token ||
      localStorage.getItem("authToken") ||
      localStorage.getItem("token") ||
      "";
    if (t) window.__AUTH_BEARER__ = t;
  }, [token]);

  const role = canonRole(user);
  const nameForChip = humanName(user);
  const doLogout = auth?.logout || (() => {});
  const allowed = ALLOWED_BY_ROLE[role] || ALLOWED_BY_ROLE.default;
  const allowedKeys = new Set(allowed);

  // ---- Capability (se disponibili) ----
  const rawCaps =
    auth?.caps ||
    auth?.permissions ||
    auth?.perms ||
    auth?.abilities ||
    (Array.isArray(user?.caps) ? user.caps : null) ||
    (Array.isArray(window.__USER_CAPS__) ? window.__USER_CAPS__ : null) ||
    [];

  const capsAvailable = Array.isArray(rawCaps) && rawCaps.length > 0;
  const hasCap = (code) => {
    if (!capsAvailable) return false;
    return (
      rawCaps.includes?.(code) ||
      rawCaps.some?.(
        (c) => c === code || c?.code === code || c?.slug === code
      )
    );
  };
  const isAdmin = role === "admin";
  const roleCanChatByDefault = ["rilevatore","senior","senior_posa","responsabile","centralino","formatore"].includes(role);
  const canUseChat = isAdmin || hasCap(CAP_CHAT) || (!capsAvailable && roleCanChatByDefault);

  const linkCls = ({ isActive }, extra) =>
    "nav-link" +
    (isActive ? " active" : "") +
    (extra ? ` ${extra}` : "");

  // Stato GPS
  const [gpsOn, setGpsOn] = useState(() => {
    const saved = localStorage.getItem("trackConsent");
    return saved === "granted" || user?.consente_tracking === 1;
  });
  const timerRef = useRef(null);

  // Stato Chat
  const [chatOpen, setChatOpen] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  const [chatInput, setChatInput] = useState("");
  const [chatUsers, setChatUsers] = useState([]);
  const [chatPeerId, setChatPeerId] = useState(""); // id utente selezionato
  const [chatPeerInfo, setChatPeerInfo] = useState(null); // {id, display_name,...}
  const [convLastAt, setConvLastAt] = useState(null);
  const [lastMsgId, setLastMsgId] = useState(0);
  const chatPingRef = useRef(null);
  // Non letti
  const [unreadByUser, setUnreadByUser] = useState({});
  const totalUnread = useMemo(
    () => Object.values(unreadByUser).reduce((acc, v) => acc + (v || 0), 0),
    [unreadByUser]
  );
  // Ref per il suono di notifica chat
  const chatSoundRef = useRef(null);

  // Ref per il body della chat (per scroll automatico)
  const chatBodyRef = useRef(null);

  // Scroll automatico in fondo quando arrivano messaggi o apro la chat
  useEffect(() => {
    if (chatBodyRef.current) {
      chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
    }
  }, [chatMessages.length, chatOpen]);






  // Carica lista utenti chat una volta
  useEffect(() => {
    if (!canUseChat || !user?.id) return;
    (async () => {
      const resp = await postJSON("/preventivi/chat/list_users.php", {});
      if (resp && resp.ok && Array.isArray(resp.users)) {
        setChatUsers([...resp.users]);
      }
    })();
  }, [canUseChat, user?.id]);

  // Tracker GPS: parte solo con identità certa e gpsOn === true
  useEffect(() => {
    const isLoginRoute = String(location?.pathname || "").includes("/login");

    if (isLoginRoute || !user?.id || !gpsOn) {
      if (timerRef.current) clearInterval(timerRef.current);
      return;
    }

    let stop = false;

    (async () => {
      const okId =
        window.__AUTH_BEARER__ ||
        localStorage.getItem("authToken") ||
        localStorage.getItem("token")
          ? true
          : await ensureIdentity();
      if (!okId || stop) return;

      const ensureConsent = async () => {
        if (user.consente_tracking === 1) {
          localStorage.setItem("trackConsent", "granted");
          setGpsOn(true);
          return true;
        }
        const saved = localStorage.getItem("trackConsent");
        if (saved === "granted") {
          setGpsOn(true);
          return true;
        }
        const ok = window.confirm(
          "Vuoi condividere la tua posizione mentre usi l’app? " +
            "Serve per mostrare la tua posizione sulla mappa agli utenti autorizzati."
        );
        try {
          await setTrackConsent(ok);
        } catch (e) {
          console.warn("setTrackConsent error:", e);
        }
        localStorage.setItem("trackConsent", ok ? "granted" : "denied");
        setGpsOn(!!ok);
        return ok;
      };

      const tick = async () => {
        if (!navigator.onLine) return;
        if (!window.__AUTH_BEARER__) {
          const ok = await ensureIdentity();
          if (!ok) return;
        }
        const consent = await ensureConsent();
        if (!consent || !navigator.geolocation) return;

        navigator.geolocation.getCurrentPosition(
          async (pos) => {
            const { latitude: lat, longitude: lon, accuracy: acc } =
              pos.coords;
            await savePosition({ lat, lon, acc });
          },
          (err) => {
            if (err?.code === 1) {
              localStorage.setItem("trackConsent", "denied");
              setGpsOn(false);
            }
          },
          { enableHighAccuracy: true, maximumAge: 30000, timeout: 8000 }
        );
      };

      await tick();
      timerRef.current = setInterval(tick, 120000);
    })();

    return () => {
      stop = true;
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [user?.id, user?.consente_tracking, location?.pathname, gpsOn]);

  // Ping chat: controlla sempre nuovi messaggi (anche con chat chiusa)
    // Ping chat: controlla sempre nuovi messaggi (anche con chat chiusa)
  useEffect(() => {
    if (!canUseChat || !user?.id) {
      if (chatPingRef.current) clearInterval(chatPingRef.current);
      return;
    }

    let stopped = false;

    const onePing = async () => {
      const resp = await postJSON("/preventivi/chat/ping.php", {
        last_msg_id: lastMsgId || 0,
      });

      if (!resp || resp.ok === false) return;
      const msgs = Array.isArray(resp.messages) ? resp.messages : [];

      // aggiorna lastMsgId se il server l'ha alzato
      if (typeof resp.last_msg_id === "number" && resp.last_msg_id > lastMsgId) {
        setLastMsgId(resp.last_msg_id);
      }
      if (msgs.length === 0) return;

      // 🔔 se arrivano nuovi messaggi mentre la chat è chiusa → pulse + (opzionale) suono
      if (!chatOpen) {
        try {
          if (!chatSoundRef.current) {
            chatSoundRef.current = new Audio("/preventivi/assets/chat_ping.mp3");
          }
          chatSoundRef.current.currentTime = 0;
          chatSoundRef.current.play().catch(() => {});
        } catch (e) {
          // ignoriamo errori audio
        }
      }

      // 🔴 aggiorna non letti per tutti i mittenti
      setUnreadByUser((prev) => {
        const next = { ...prev };
        for (const m of msgs) {
          const fromId = m.from_user_id;
          if (!fromId) continue;
          // se sto già guardando quella chat, non incremento i non letti
          if (chatOpen && chatPeerId && Number(chatPeerId) === Number(fromId)) continue;
          next[fromId] = (next[fromId] || 0) + 1;
        }
        return next;
      });

      // se la chat è aperta su un peer specifico, appendi solo i suoi messaggi
      if (chatOpen && chatPeerId) {
        const peerIdNum = Number(chatPeerId);
        const forThisPeer = msgs.filter(
          (m) => m.from_user_id === peerIdNum && m.to_user_id === user.id
        );
        if (forThisPeer.length > 0) {
          setChatMessages((prev) => {
            const merged = [...prev];
            for (const m of forThisPeer) {
              if (!merged.some((x) => x.id === m.id)) merged.push(m);
            }
            return merged;
          });
          const last = forThisPeer[forThisPeer.length - 1];
          if (last && last.created_at) {
            setConvLastAt(last.created_at);
          }
        }
      }
    };

    onePing();
    chatPingRef.current = setInterval(() => {
      if (!stopped) onePing();
    }, 15000);

    return () => {
      stopped = true;
      if (chatPingRef.current) clearInterval(chatPingRef.current);
    };
  }, [canUseChat, user?.id, chatOpen, chatPeerId, lastMsgId]);





  
  const toggleGps = async () => {
    const want = !gpsOn;
    try {
      await setTrackConsent(want);
    } catch (e) {
      console.warn("setTrackConsent error:", e);
    }
    localStorage.setItem("trackConsent", want ? "granted" : "denied");
    setGpsOn(want);

    if (!want) {
      if (timerRef.current) clearInterval(timerRef.current);
      return;
    }

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (pos) => {
          const { latitude: lat, longitude: lon, accuracy: acc } =
            pos.coords;
          await savePosition({ lat, lon, acc });
        },
        () => {},
        { enableHighAccuracy: true, maximumAge: 30000, timeout: 8000 }
      );
    }
  };

  const handleChatSend = async (e) => {
    e.preventDefault();
    const body = chatInput.trim();
    const toId = Number(chatPeerId);
    if (!body || !toId) return;

    const resp = await postJSON("/preventivi/chat/send_message.php", {
      to_user_id: toId,
      body,
    });

    if (resp && resp.ok) {
      setChatInput("");
      const createdAt = new Date()
        .toISOString()
        .slice(0, 19)
        .replace("T", " ");
      setChatMessages((prev) => [
        ...prev,
        {
          id: resp.id || Date.now(),
          from_user_id: user.id,
          to_user_id: toId,
          body,
          created_at: createdAt,
          read_at: null,
          from_name: humanName(user),
        },
      ]);
      setConvLastAt(createdAt);
    }
  };



  const toggleChat = () => {
    setChatOpen((prev) => {
      const next = !prev;
      if (next) {
        // Sto APRENDO la chat: considero tutti i messaggi come "visti"
        setUnreadByUser({});
      }
      return next;
    });
  };





  const handleSelectPeer = async (e) => {
    const val = e.target.value;
    setChatPeerId(val);
    if (!val) {
      setChatPeerInfo(null);
      setChatMessages([]);
      setConvLastAt(null);
      return;
    }
    const peerIdNum = Number(val);
    const peer = chatUsers.find((u) => Number(u.id) === peerIdNum) || null;
    setChatPeerInfo(peer || null);

    // carica history
    const resp = await postJSON("/preventivi/chat/history.php", {
      peer_user_id: peerIdNum,
      limit: 200,
    });

    if (!resp || !resp.ok) {
      setChatMessages([]);
      setConvLastAt(null);
      return;
    }

    const msgs = Array.isArray(resp.messages) ? resp.messages : [];
    setChatMessages(msgs);
    setConvLastAt(resp.last_at || null);

    if (msgs.length > 0) {
      const maxId = Math.max(...msgs.map((m) => Number(m.id) || 0));
      setLastMsgId((prev) => (maxId > prev ? maxId : prev));
    }

    // azzera non letti per questo peer
    setUnreadByUser((prev) => {
      const next = { ...prev };
      delete next[peerIdNum];
      return next;
    });
  };

  return (
    <header className="navbar-admin" data-src="navbar.jsx">
      <div className="inner">
        <nav className="links" aria-label="Navigazione principale">
          {MENU_ITEMS
            .filter((it) => allowedKeys.has(it.key))
            .filter(
              (it) =>
                it.key !== "gestione" ||
                isAdmin ||
                !capsAvailable ||
                hasCap(CAP_GESTIONE)
            )
            .map((it) => (
              <NavLink
                key={it.key}
                to={it.to}
                className={(args) => linkCls(args, it.extraCls)}
                aria-label={it.label}
                data-key={it.key}
                title={it.label}
              >
                <Icon name={it.icon} />
                <span className="lbl">{it.label}</span>
              </NavLink>
            ))}
        </nav>

        <div className="spacer" />

        {/* Pulsante Chat */}
{canUseChat && (
  <button
    type="button"
    className={`chat-chip ${chatOpen ? "open" : ""} ${!chatOpen && totalUnread > 0 ? "pulse" : ""}`}
    onClick={toggleChat}
    title={chatOpen ? "Chiudi messaggi" : "Apri messaggi"}
    aria-label="Messaggi interni"
  >
    <Icon name="chat" />
    <span className="lbl">Chat</span>
    {totalUnread > 0 && (
      <span className="chat-badge">
        {totalUnread > 9 ? "9+" : totalUnread}
      </span>
    )}
  </button>
)}





        {/* Chip GPS */}
        <button
          type="button"
          className={`gps-chip ${gpsOn ? "on" : "off"}`}
          onClick={toggleGps}
          title={gpsOn ? "GPS attivo" : "GPS disattivo"}
          aria-label={gpsOn ? "GPS ON" : "GPS OFF"}
        >
          <Icon name="gps" />
          <span className="lbl">{gpsOn ? "GPS ON" : "GPS OFF"}</span>
        </button>

        <span
          className="admin-chip"
          title={`${nameForChip} · ruolo: ${role || "?"}`}
        >
          {nameForChip} · {role || "?"}
        </span>

        <button
          className="btn-logout"
          type="button"
          onClick={() => {
            if (timerRef.current) clearInterval(timerRef.current);
            if (chatPingRef.current) clearInterval(chatPingRef.current);
            window.__AUTH_BEARER__ = "";
            navigate("/", { replace: true });
            doLogout();
          }}
          aria-label="Logout"
          title="Logout"
        >
          <Icon name="lock" />
          <span className="lbl">Logout</span>
        </button>
      </div>

      {/* Pannellino chat */}
      {canUseChat && chatOpen && (
        <div className="chat-panel">
          <div className="chat-panel-header">
            <span>Messaggi</span>
            {chatPeerInfo && (
              <span className="chat-peer-name">
                · {chatPeerInfo.display_name || chatPeerInfo.username}
              </span>
            )}
          </div>
          {chatPeerInfo && (
            <div className="chat-panel-subheader">
              {convLastAt
                ? `Ultimo messaggio: ${formatDateTime(convLastAt)}`
                : "Nessun messaggio in questa conversazione"}
            </div>
          )}
           <div className="chat-panel-body" ref={chatBodyRef}>
            {!chatPeerId ? (
              <div className="chat-empty">
                Seleziona un destinatario per vedere la conversazione.
              </div>
            ) : chatMessages.length === 0 ? (
              <div className="chat-empty">Nessun messaggio.</div>
            ) : (
              
                            <div className="chat-messages">
                {chatMessages.map((m, idx) => {
                  const isMe = m.from_user_id === user.id;
                  const seen = isMe && m.read_at;

                  // primo messaggio NON letto in arrivo dall'altro
                  const isFirstUnread =
                    !isMe &&
                    !m.read_at &&
                    chatMessages.findIndex(
                      (mm) => !mm.read_at && mm.from_user_id !== user.id
                    ) === idx;

                  return (
                    <React.Fragment key={m.id}>
                      {isFirstUnread && (
                        <div className="chat-divider">
                          ✉️ Messaggi non letti
                        </div>
                      )}
                      <div
                        className={"chat-msg " + (isMe ? "me" : "other")}
                      >
                        <div className="chat-msg-from">
                          {m.from_name || `#${m.from_user_id}`}
                        </div>
                        <div className="chat-msg-body">{m.body}</div>
                        {isMe && (
                          <div className="chat-msg-meta">
                            {seen ? "visto" : "inviato"}
                          </div>
                        )}
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>

            )}
          </div>
          <form className="chat-panel-form" onSubmit={handleChatSend}>
<select
  className="chat-to-select"
  value={chatPeerId}
  onChange={handleSelectPeer}
>
  <option value="">Destinatario…</option>
  {chatUsers
    .filter((u) => Number(u.id) !== Number(user.id))
    .map((u) => {
      const unread = unreadByUser[u.id] || 0;
      return (
        <option key={u.id} value={u.id}>
          {unread > 0 ? "🔴 " : ""}
          {u.display_name || u.username} ({u.role_slug})
        </option>
      );
    })}
</select>

            <input
              type="text"
              className="chat-input"
              placeholder="Scrivi un messaggio…"
              value={chatInput}
              onChange={(e) => setChatInput(e.target.value)}
              disabled={!chatPeerId}
            />
            <button
              type="submit"
              className="chat-send-btn"
              disabled={!chatPeerId || !chatInput.trim()}
            >
              Invia
            </button>
          </form>
        </div>
      )}

      {/* Stili inline specifici della navbar */}
            <style>{`
        .navbar-admin .inner{
          display:flex;
          align-items:center;
          gap:8px;
        }
        .navbar-admin .links{
          display:flex;
          flex-wrap:nowrap!important;
          gap:12px;
          min-width:0;
          overflow-x:auto;
          -webkit-overflow-scrolling:touch;
          scrollbar-width:thin;
        }
        .navbar-admin .links::-webkit-scrollbar{ height:5px }
        .navbar-admin .links::-webkit-scrollbar-thumb{
          background: rgba(255,255,255,.25);
          border-radius:999px;
        }
        .navbar-admin .nav-link{
          height:32px;
          padding:0 13px;
          white-space:nowrap;
          border-radius:999px;
          display:inline-flex;
          align-items:center;
          gap:8px;
        }
        .navbar-admin .nav-ic{
          width:18px;
          height:18px;
          flex:0 0 auto;
        }
        .navbar-admin .nav-link .lbl{
          font-size:14px;
          line-height:1;
        }
        .navbar-admin .spacer{ flex:1 1 auto; }

        .navbar-admin .gps-chip,
        .navbar-admin .chat-chip{
          display:inline-flex;
          align-items:center;
          gap:6px;
          height:28px;
          padding:0 10px;
          border-radius:999px;
          border:1px solid transparent;
          font-size:12px;
          cursor:pointer;
          white-space:nowrap;
          background:transparent;
        }
        .navbar-admin .gps-chip .nav-ic,
        .navbar-admin .chat-chip .nav-ic{
          width:16px;
          height:16px;
        }

        .navbar-admin .gps-chip.on{
          background:linear-gradient(180deg,#d1fae5,#86efac);
          color:#064e3b;
          border-color:#10b981;
        }
        .navbar-admin .gps-chip.off{
          background:linear-gradient(180deg,#fee2e2,#fecaca);
          color:#7f1d1d;
          border-color:#ef4444;
        }

        .navbar-admin .chat-chip{
          position:relative;
          background:linear-gradient(180deg,#e0f2fe,#bfdbfe);
          color:#1e3a8a;
          border-color:#3b82f6;
        }
        .navbar-admin .chat-chip.open{
          background:linear-gradient(180deg,#bfdbfe,#93c5fd);
          color:#1d4ed8;
          border-color:#1d4ed8;
        }
        .navbar-admin .chat-badge{
          position:absolute;
          top:-4px;
          right:-4px;
          min-width:16px;
          height:16px;
          padding:0 4px;
          border-radius:999px;
          background:#dc2626;
          color:#f9fafb;
          font-size:10px;
          display:flex;
          align-items:center;
          justify-content:center;
        }

        /* Animazione icona chat quando ci sono non letti e chat chiusa */
        .navbar-admin .chat-chip.pulse{
          animation: chat-pulse 1s infinite;
        }
        @keyframes chat-pulse{
          0%   { transform: scale(1); box-shadow:none; }
          50%  { transform: scale(1.06); box-shadow:0 0 8px rgba(239,68,68,.7); }
          100% { transform: scale(1); box-shadow:none; }
        }

        .navbar-admin .nav-emoji{
          display:inline-flex;
          align-items:center;
          justify-content:center;
          width:auto;
          height:auto;
          font-size:16px;
          line-height:1;
        }
        .navbar-admin .chat-chip .nav-emoji{
          font-size:18px;
        }

        .navbar-admin .admin-chip{
          margin:0 8px;
          white-space:nowrap;
          padding:6px 10px;
          border-radius:999px;
          background:rgba(0,0,0,.15);
          color:#fff;
          font-weight:600;
        }
        .navbar-admin .btn-logout{
          height:32px;
          padding:0 12px;
          border-radius:999px;
          display:inline-flex;
          align-items:center;
          gap:8px;
          background:#ef4444;
          color:#fff;
          border:0;
        }
        .navbar-admin .btn-logout .nav-ic{
          width:18px;
          height:18px;
        }

        /* Colorazioni speciali dei tab principali */
        .navbar-admin .nav-link.nav-agenda-pro,
        .navbar-admin .nav-link[data-key="agendaPro"]{
          background:linear-gradient(180deg,#ffd84d,#f7c600);
          border:1px solid #d4a017;
          color:#111827;
        }
        .navbar-admin .nav-link.nav-agenda-posa,
        .navbar-admin .nav-link[data-key="agendaPosa"]{
          background:linear-gradient(180deg,#14532d,#166534);
          border:1px solid #064e3b;
          color:#eafbe7;
        }
        .navbar-admin .nav-link.nav-acl,
        .navbar-admin .nav-link[data-key="acl"]{
          background:linear-gradient(180deg,#38bdf8,#0ea5e9);
          border:1px solid #0284c7;
          color:#073042;
        }
        .navbar-admin .nav-link.nav-stats,
        .navbar-admin .nav-link[data-key="statistiche"]{
          background:linear-gradient(180deg,#fca5a5,#f87171);
          border:1px solid #dc2626;
          color:#111827;
        }
        .navbar-admin .nav-link.nav-gestione,
        .navbar-admin .nav-link[data-key="gestione"]{
          background:linear-gradient(180deg,#6aa6ff,#2f5bff);
          border:1px solid #1d4ed8;
          color:#0b1220;
        }

        /* Pannello chat */
        .chat-panel{
          position:fixed;
          right:16px;
          bottom:16px;
          width:380px;
          max-height:70vh;
          background:#f9fafb;
          border-radius:16px;
          box-shadow:0 8px 20px rgba(0,0,0,.3);
          display:flex;
          flex-direction:column;
          overflow:hidden;
          z-index:9999;
          font-size:13px;
        }
        .chat-panel-header{
          background:linear-gradient(180deg,#1d4ed8,#1e40af);
          color:#e5e7eb;
          padding:6px 10px;
          font-weight:600;
          display:flex;
          align-items:center;
          gap:4px;
        }
        .chat-peer-name{
          font-weight:500;
          font-size:12px;
        }
        .chat-panel-subheader{
          padding:4px 10px;
          font-size:11px;
          color:#374151;
          background:#e5e7eb;
        }
        .chat-panel-body{
          flex:1 1 auto;
          padding:6px;
          overflow:auto;
          background:#eff6ff;
        }
        .chat-empty{
          padding:12px 8px;
          text-align:center;
          color:#6b7280;
          font-style:italic;
        }
        .chat-messages{
          display:flex;
          flex-direction:column;
          gap:4px;
        }

        /* Divisore "Messaggi non letti" */
        .chat-divider{
          text-align:center;
          font-size:11px;
          color:#6b7280;
          margin:6px 0;
          position:relative;
        }
        .chat-divider::before,
        .chat-divider::after{
          content:"";
          position:absolute;
          top:50%;
          width:30%;
          height:1px;
          background:#d1d5db;
        }
        .chat-divider::before{ left:5%; }
        .chat-divider::after{ right:5%; }

        .chat-msg{
          padding:4px 6px;
          border-radius:8px;
          max-width:90%;
          word-wrap:break-word;
        }
        .chat-msg.me{
          margin-left:auto;
          background:#d1fae5;
          color:#064e3b;
        }
        .chat-msg.other{
          margin-right:auto;
          background:#e5e7eb;
          color:#111827;
        }
        .chat-msg-from{
          font-size:11px;
          font-weight:600;
          opacity:0.8;
          margin-bottom:2px;
        }
        .chat-msg-body{
          font-size:13px;
        }
        .chat-msg-meta{
          font-size:10px;
          margin-top:2px;
          opacity:0.8;
          text-align:right;
        }
        .chat-panel-form{
          display:flex;
          gap:4px;
          padding:6px;
          border-top:1px solid #d1d5db;
          background:#f3f4f6;
        }
        .chat-to-select{
          width:140px;
          padding:2px 4px;
          font-size:11px;
          border-radius:8px;
          border:1px solid #cbd5f5;
        }
        .chat-input{
          flex:1 1 auto;
          padding:2px 6px;
          font-size:12px;
          border-radius:8px;
          border:1px solid #cbd5f5;
        }
        .chat-send-btn{
          padding:2px 8px;
          font-size:12px;
          border-radius:999px;
          border:0;
          background:#2563eb;
          color:#f9fafb;
          cursor:pointer;
        }
        .chat-send-btn:disabled{
          opacity:0.5;
          cursor:default;
        }
        .chat-send-btn:hover:not(:disabled){
          background:#1d4ed8;
        }

        /* --- COMPATTA SOTTO 1600px: SOLO ICONE --- */
        @media (max-width:1600px){
          .navbar-admin .links{ gap:8px; }
          .navbar-admin .nav-link{ padding:0 8px; }
          .navbar-admin .nav-link .lbl{ display:none; }
          .navbar-admin .gps-chip .lbl,
          .navbar-admin .chat-chip .lbl{ display:none; }
          .navbar-admin .gps-chip,
          .navbar-admin .chat-chip{ padding:0 8px; }
          .navbar-admin .admin-chip{ padding:4px 8px; font-size:12px; }
          .navbar-admin .btn-logout .lbl{ display:none; }
          .navbar-admin .btn-logout{ padding:0 8px; }
        }

        /* Ultra-compatto per tablet/phone */
        @media (max-width:760px){
          .navbar-admin .nav-ic{ width:16px; height:16px; }
          .navbar-admin .btn-logout{ height:28px; }
          .navbar-admin .admin-chip{ display:none; }

          .chat-panel{
            left:8px;
            right:8px;
            bottom:8px;
            width:auto;
            max-height:60vh;
          }
        }
      `}</style>

    </header>
  );
}
